export default "__VITE_ASSET__BEYayAr9__"